module.exports = __webpack_public_path__ + "static/media/go_to.dfd1644c.svg";